import { element, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const InstructionsForUseProperties = {
    instructionsForUse: {
        type: string,
    },
    logoIcon: {
        defaultValue: '/static/assets/philips-shield.svg',
        type: oneOfType([string, element]),
    },
    productName: {
        type: string,
    },
};
export { InstructionsForUseProperties, };
//# sourceMappingURL=instructions-for-use-types.js.map